import AddBoxIcon from '@material-ui/icons/AddBox';
import CloseIcon from '@material-ui/icons/Close';
import SubdirectoryArrowRightIcon from '@material-ui/icons/SubdirectoryArrowRight';
import { useLinked } from "@type-r/react";
import { div } from "lqx-react/lib";
import React from "react";
import { TargetFieldCard, TargetFieldType } from "../../../api/targetFieldCard";
import { DigiSelect } from "../../../components/select";
import { DigiCheckbox, DigiTooltip, limitText } from "../../../shared";
import { MappingItem } from "../../models/import-template-details";
import { importTemplate } from "../../models/import-wizard-constants";
import { GlobalFieldSelectionPopup } from './global-field-selection-popup';

export const SelectOption = ({ mappingItem, inBlockMappingFields, onSelect, onDelete, onCheck, onSelectMultipleSource, onFormattingSelect }
    : { mappingItem: MappingItem, inBlockMappingFields?: TargetFieldCard[], onSelect: any, onDelete?: any, onCheck?: any, onSelectMultipleSource?: any, onFormattingSelect?: any }) => {

    const getTargetField = (id) => inBlockMappingFields.find(x => x.id === id);

    const $isGlobalValuePositionPopupOpen = useLinked(false);
    const $globalValuePosition = useLinked(mappingItem.from.globalValuePosition)
    const $globalHeader = useLinked(mappingItem.from.isGlobal).onChange(x => {
        $isGlobalValuePositionPopupOpen.set(x)
        if (!Boolean(x)) {
            onCheck(mappingItem.from.x, mappingItem.from.y, false, null)
        }
    }
    );

    const $dropDownLinked = useLinked(mappingItem.to).onChange(x => {
        if (Boolean(x.id) && x.id !== mappingItem.to.id) {
            const targetField = getTargetField(x.id);
            const selectedOptionName = x.id !== importTemplate.selectOption.id ? targetField.name : importTemplate.selectOption.name;

            onSelect(mappingItem.from.name, mappingItem.from.x, mappingItem.from.y, x.id, selectedOptionName, mappingItem.isChild, $globalHeader.value, $globalValuePosition.value, targetField.targetFieldTypeId, mappingItem.index);
            $targetFieldLinked.set(targetField);
        }
    });

    const $formattingLinked = useLinked(mappingItem.from.formatting ? mappingItem.from.formatting : { name: 'Default', value: '' }).onChange(x =>
        onFormattingSelect(mappingItem.from.x, mappingItem.from.y, x, $targetFieldLinked.value.targetFieldTypeId)
    );

    const $targetFieldLinked = useLinked(getTargetField(mappingItem.to.id));

    const onClose = (val) => {
        $isGlobalValuePositionPopupOpen.set(false);
        if (val) {
            $globalValuePosition.set(val);
            onCheck(mappingItem.from.x, mappingItem.from.y, true, val);
        } else {
            $globalHeader.set(false)
        }
    }

    return (<>
        <MappingRow>
            {mappingItem.isChild
                ? <SubDirectoryIcon>
                    <SubdirectoryArrowRightIcon />
                </SubDirectoryIcon>

                : <AddIconBtn>
                    <AddBoxIcon onClick={() => { onSelectMultipleSource(mappingItem.from.name, mappingItem.from.x, mappingItem.from.y, '0', '--- Select an option ---', true, $globalHeader.value, $globalValuePosition.value, TargetFieldType.Text) }} />
                </AddIconBtn>
            }

            <SourceFileColumn>
                <DigiTooltip title={mappingItem.from.name}>
                    <span>{limitText(mappingItem.from.name, 11)}</span>
                </DigiTooltip>
            </SourceFileColumn>
            <FormattingColumn>
                {$targetFieldLinked.value.targetFieldTypeId && $targetFieldLinked.value.getTargetFieldType() === TargetFieldType.Text
                    ? <>Text</>
                    : <></>}
                {$targetFieldLinked.value.targetFieldTypeId && $targetFieldLinked.value.getTargetFieldType() === TargetFieldType.DateTime
                    ? <DigiSelect data-qa-id="formattingFields" id="value" label="name" $value={$formattingLinked} options={dateTimeFormats} styles={selectStyles}></DigiSelect>
                    : <></>}
            </FormattingColumn>
            <MapFieldColumn>
                <DigiSelect data-qa-id="inBlockMappingFields" id="id" label="name" $value={$dropDownLinked} options={inBlockMappingFields} styles={selectStyles}></DigiSelect>
            </MapFieldColumn>
            {mappingItem.isChild
                ? <CheckboxEmptyColumn></CheckboxEmptyColumn>
                : <CheckboxColumn>
                    {<div title={$globalHeader.value ? $globalValuePosition.value : ""}><DigiCheckbox $checked={$globalHeader} /></div>}
                    {$isGlobalValuePositionPopupOpen.value && (
                        <GlobalFieldSelectionPopup onClose={onClose}></GlobalFieldSelectionPopup>)
                    }
                </CheckboxColumn>
            }
            <CloseBtn>
                <CloseIcon onClick={() => onDelete(mappingItem.from.name, mappingItem.isChild, mappingItem.index)} />
            </CloseBtn>
        </MappingRow>
    </>
    );
};

const CheckboxEmptyColumn = div({
    width: '42px'
});

const CloseBtn = div({
    alignSelf: 'center',
    height: '22px',
    cursor: 'pointer'
});

const SourceFileColumn = div({
    flex: '0 0 100px',
    color: '#767D84',
    alignSelf: 'center'
})

const FormattingColumn = div({
    flex: '0 0 120px',
    alignSelf: 'center',
})

const MapFieldColumn = div({
    flex: '1',
    alignSelf: 'center',
})

const CheckboxColumn = div({
});

const MappingRow = div({
    display: 'flex',
    flexDirection: 'row',
    backgroundColor: 'whitesmoke',
    marginTop: 3,
    marginBottom: 3,
    borderRadius: 2,
    padding: '2px 3px',
    fontSize: '12px',
    fontFamily: 'Montserrat',
    fontWeight: 500,
});

const AddIconBtn = div({
    alignSelf: 'center',
    color: "#0098DB",
    transform: 'scale(1.3)',
    margin: '0 5px 0 5px',
    cursor: 'pointer'
});

const SubDirectoryIcon = div({
    alignSelf: 'center',
    transform: 'scale(1.3)',
    margin: '0 5px 0 5px'
});

const selectStyles = {
    container: provided => ({
        ...provided,
        width: '100%',
        height: 26,
        marginBottom: 0,
    }),
    control: provided => ({
        ...provided,
        borderColor: '#E3E9ED',
        minHeight: 26,
        marginRight: 5,
    }),
    valueContainer: (provided) => ({
        ...provided,
        fontSize: 12,
        height: 26,
        padding: '0px 0px',
    })
}

const dateTimeFormats = [
    { name: 'Default', value: '' },
    { name: 'MM/DD/YYYY', value: 'MM/dd/yyyy' },
    { name: 'DD/MM/YYYY', value: 'dd/MM/yyyy' },
    { name: 'YYYY/MM/DD', value: 'yyyy/MM/dd' },
    { name: 'MM/DD/YY', value: 'MM/dd/yy' },
    { name: 'DD/MM/YY', value: 'dd/MM/yy' },
    { name: 'YY/MM/DD', value: 'yy/MM/dd' },
    { name: 'MMM dd, yyyy', value: 'MMM dd, yyyy' },
    { name: 'MMMM dd, yyyy', value: 'MMMM dd, yyyy' },
    { name: 'MM-DD-YYYY', value: 'MM-dd-yyyy' },
    { name: 'DD-MM-YYYY', value: 'dd-MM-yyyy' },
    { name: 'MM-DD-YY', value: 'MM-dd-yy' },
    { name: 'DD-MM-YY', value: 'dd-MM-yy' },
];
